<script setup>
defineProps({
  breadcrumbs: {
    type: Array,
    required: false,
    default() {
      return []
    },
  },
})
</script>

<template>
  <div class="flex items-center font-mono uppercase">
    <NuxtLink itemprop="item" class="text-sm text-gray-600" :to="'/'">
      Home
    </NuxtLink>

    <IconChevronRight class="mx-2 h-3 text-gray-600" />

    <ol
      itemscope
      itemtype="https://schema.org/BreadcrumbList"
      class="flex items-center text-sm"
    >
      <li
        v-for="(breadcrumb, index) of breadcrumbs"
        :key="index"
        itemprop="itemListElement"
        itemscope
        itemtype="https://schema.org/ListItem"
        class="flex items-center"
      >
        <NuxtLink
          v-if="index + 1 !== breadcrumbs.length"
          itemprop="item"
          :to="breadcrumb.link"
          class="text-gray-600"
        >
          <span itemprop="name">{{ breadcrumb.title }}</span>
        </NuxtLink>
        <span v-else itemprop="name" class="text-gray-800">{{
          breadcrumb.title
        }}</span>
        <meta itemprop="position" :content="index + 1" />
        <IconChevronRight
          v-if="index + 1 !== breadcrumbs.length"
          class="mx-2 h-3 text-gray-600"
        />
      </li>
    </ol>
  </div>
</template>
